export const preventFn = (event) => event.preventDefault();
